import React, { useState, useEffect } from "react";
import "./Header.css";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  return (
    <>
      <header className={`header ${scrolled ? "scrolled" : ""}`}>
        <div className="logo">
          <a href="/" className="logo-link">
            <img src="/homeButtonLogo.png" alt="Logo" className="logo-img" />
          </a>
        </div>
        <nav className="nav">
          <ul className="nav-list">
            <li>
              <a href="/AboutUs" className="nav-item">
                ABOUT US
              </a>
            </li>
            <li>
              <a href="/Engineering&Safety" className="nav-item">
                ENGINEERING & SAFETY
              </a>
            </li>

            <li>
              <a href="/Parts&Services" className="nav-item">
                PARTS & SERVICES
              </a>
            </li>
            <li>
              <a href="/XCube" className="nav-item">
                X CUBE
              </a>
            </li>
          </ul>
        </nav>
        <div className="hamburger-menu" onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
      </header>

      <nav className={`nav2 ${isMenuOpen ? "open" : ""}`}>
        <ul className="nav-list">
          <li>
            <a href="/AboutUs" className="nav-item">
              ABOUT US
            </a>
          </li>
          <li>
            <a href="/Engineering&Safety" className="nav-item">
              ENGINEERING & SAFETY
            </a>
          </li>

          <li>
            <a href="/Parts&Services" className="nav-item">
              PARTS & SERVICES
            </a>
          </li>
          <li>
            <a href="/XCube" className="nav-item">
              X CUBE
            </a>
          </li>
        </ul>
      </nav>
    </>
  );
};

export default Header;
